import {Mapper} from '@s-ui/domain'

import {FiltersSearchValueObject} from '../../search/ValueObjects/FiltersSearchValueObject.js'

export class FromUserAlertRawDataToUserAlertEntityMapper extends Mapper {
  constructor({config, userAlertEntityFactory}) {
    super()
    this._config = config
    this._userAlertEntityFactory = userAlertEntityFactory
    this._DEFAULT_CATEGORY1_ID = config.get('search').DEFAULT_CATEGORY1_ID
    this._FREQUENCY_NOTIFICATION_DAILY = config.get('alerts').FREQUENCY_NOTIFICATION_DAILY
    this._FREQUENCY_NOTIFICATION_REALTIME = config.get('alerts').FREQUENCY_NOTIFICATION_REALTIME
    this._allOfferTypes = config.get('search').ALL_OFFER_TYPES
    this._unselectedOfferType = config.get('search').UNSELECTED_OFFER_TYPE
    this._allOfferTypesInSecondHand = config.get('search').ALL_OFFER_TYPES_IN_SECOND_HAND
    this._allOfferTypesInKm0 = config.get('search').ALL_OFFER_TYPES_IN_KM0
    this._offerTypeSecondHand = config.get('search').OFFER_TYPE_SECOND_HAND
    this._offerTypeNewVehicle = config.get('search').OFFER_TYPE_NEW
    this._offerTypeKm0 = config.get('search').OFFER_TYPE_KM0
    this._offerTypeSubscription = config.get('search').OFFER_TYPE_SUBSCRIPTION
    this._listingSectionIdsByCategories = config.get('stock').LISTING_SECTION_IDS_BY_CATEGORIES
  }

  _getFrequencyNotification = ({emailFrequency, pushFrequency}) =>
    emailFrequency !== pushFrequency ? this._FREQUENCY_NOTIFICATION_REALTIME : pushFrequency

  _getSelectedFiltersNumber = ({categories, equipmentText, vehicles, ...filters}) => {
    const numOfVehicleFilters = (vehicles && Object.keys(vehicles[0]).length) || 0

    const numOfFiltersWithFalseValue = Object.keys(filters).filter(element => filters[element] === false)?.length || 0

    return Object.keys(filters).length + numOfVehicleFilters - numOfFiltersWithFalseValue
  }

  map = data => {
    const {activeEmail, activePush, alertId, alertName, emailFrequency, pushFrequency, filters} = data

    const numOfFiltersSelected = this._getSelectedFiltersNumber(filters)

    const frequencyNotification = this._getFrequencyNotification({
      emailFrequency,
      pushFrequency
    })

    const [categoryId] = filters.categories?.category1Ids || []
    const [offerTypeId] = filters.offerTypeIds || []

    const relatedListingSectionId = FiltersSearchValueObject.getRelatedListingSectionId({
      config: this._config,
      categoryId: categoryId || this._DEFAULT_CATEGORY1_ID,
      offerTypeId
    })

    const filtersSearchValueObject = FiltersSearchValueObject.createFromApi({
      config: this._config,
      filters,
      listingSectionId: relatedListingSectionId
    })

    return this._userAlertEntityFactory({
      activeEmail,
      activePush,
      alertId,
      alertName,
      filters: filtersSearchValueObject.getSearchForFilters(),
      frequencyNotification,
      listingSectionId: relatedListingSectionId,
      numOfFiltersSelected
    })
  }
}
